export const addFigureMenu = `
                                      
                                      <input class="figureColorInput" type="color" value="#FF8300" />

                                      <input class="figureSizeInput" type="number" value="160" min="1" max="500" />

                                      <button>
                                        <img class="trash-img" src=${require('../images/trash-icon.PNG')} alt="delete" />
                                      </button>                                

                                    `;